import { logger as LOG } from '@garnish/logger';

// ────────────────────────────────────────────────────────────────────────────────
export const logger = LOG.extend('URQL');
// LOG.enable('URQL');
// ────────────────────────────────────────────────────────────────────────────────
